// Hàm liên quan đến việc xử lý chuỗi

// 1. Hàm xoá dấu
export function deleteMark(str) {
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a')
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e')
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i')
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o')
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u')
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y')
  str = str.replace(/đ/g, 'd')
  str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A')
  str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E')
  str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I')
  str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O')
  str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U')
  str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y')
  str = str.replace(/Đ/g, 'D')
  return str
}

// 2. Hàm xoá dấu cách thừa
export function deleteExtraSpaces(str) {
  // Gộp nhiều dấu space thành 1 space
  str = str.replace(/\s+/g, ' ')
  // loại bỏ toàn bộ dấu space (nếu có) ở 2 đầu của xâu
  str.trim()

  return str
}

// 3. Loại bỏ tất cả các kí tự không phải chữ cái và số
export const removeSpecialCharacters = (str) => {
  str = str.replace(
    /[^0-9a-zàáạảãâầấậẩẫăằắặẳẵèéẹẻẽêềếệểễìíịỉĩòóọỏõôồốộổỗơờớợởỡùúụủũưừứựửữỳýỵỷỹđ\s]/gi,
    '',
  )

  return str
}

/**
 * 4. Hàm xử lý xoá các ký tự đặc biệt trên url (Chỉ cho phép nhập từ a-z, A-Z, 0-9, -, _ ).
 * @param {*} str
 * @returns string
 */
export const removeInvalidCharacterOnURL = (str = '') => {
  str = str.replace(/[^0-9a-z\s-_]/gi, '') // chỗ này nếu bỏ \s đi thì  khi nhập chữ tiếng việt nó sẽ xoá mất một ký tự nào đó đi (chỗ này hơi khó hiểu trong js)
  // Vì vậy mới có dòng tiếp theo để xoá khoảng trắng

  str = str.replaceAll(' ', '') // replace ký tự ' ' dấu space thành ''
  return str
}

// 5. Thông thường code sẽ chỉ chứa ký tự chữ và số
export const removeInvalidCode = (str = '') => {
  str = str.replace(/[^0-9a-z\s]/gi, '') // chỗ này nếu bỏ \s đi thì  khi nhập chữ tiếng việt nó sẽ xoá mất một ký tự nào đó đi (chỗ này hơi khó hiểu trong js)
  // Vì vậy mới có dòng tiếp theo để xoá khoảng trắng

  str = str.replaceAll(' ', '') // replace ký tự ' ' dấu space thành ''
  return str
}

/** func viết hoa chữ cái đầu */
export const capitalize = (s) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}
